import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Fancybox as NativeFancybox } from '@fancyapps/ui/dist/fancybox.esm.js'
import '@fancyapps/ui/dist/fancybox.css'

const Fancybox = ({
    delegate = '[data-fancybox]',
    options = {},
    children,
}) => {
    useEffect(() => {
        NativeFancybox.bind(delegate, options)

        return () => {
            NativeFancybox.destroy()
        }
    }, [])

    return <>{children}</>
}

export default Fancybox

Fancybox.propTypes = {
    delegate: PropTypes.string,
    options: PropTypes.shape({}),
    children: PropTypes.element,
}
